// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { ChevronLeft, ChevronRight, Settings } from 'lucide-react';

// const Pagination = ({
//   totalItems,
//   itemsPerPage,
//   currentPage,
//   onPageChange,
//   onItemsPerPageChange,
// }) => {
//   const dropdownRef = useRef();
//   const buttonRef = useRef();
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [dropdownPosition, setDropdownPosition] = useState({
//     top: 'auto',
//     bottom: 'auto',
//     left: 'auto',
//     right: 'auto',
//     transformOrigin: 'top'
//   });
  
//   const perPageOptions = [10, 25, 50, 75, 100, 200, 'All'];

//   const totalPages =
//     itemsPerPage === 'All' ? 1 : Math.ceil(totalItems / itemsPerPage);

//   const startItem = itemsPerPage === 'All' ? 1 : (currentPage - 1) * itemsPerPage + 1;
//   const endItem =
//     itemsPerPage === 'All'
//       ? totalItems
//       : Math.min(currentPage * itemsPerPage, totalItems);

//   // Calculate dropdown position with viewport awareness
//   const calculatePosition = useCallback(() => {
//     if (!buttonRef.current || !isDropdownOpen) return;

//     const buttonRect = buttonRef.current.getBoundingClientRect();
//     const viewport = {
//       width: window.innerWidth,
//       height: window.innerHeight
//     };
    
//     // Dropdown dimensions
//     const dropdownWidth = 128; // w-32 = 8rem = 128px
//     const dropdownHeight = perPageOptions.length * 40; // Approximate height based on items
//     const padding = 10; // Padding from viewport edges
    
//     let position = {
//       top: 'auto',
//       bottom: 'auto',
//       left: 'auto',
//       right: 'auto',
//       transformOrigin: 'top left'
//     };

//     // Vertical positioning
//     const spaceBelow = viewport.height - buttonRect.bottom - padding;
//     const spaceAbove = buttonRect.top - padding;
    
//     if (spaceBelow >= dropdownHeight) {
//       // Enough space below
//       position.top = `${buttonRect.height + 8}px`; // mt-2 = 0.5rem = 8px
//       position.transformOrigin = 'top left';
//     } else if (spaceAbove >= dropdownHeight) {
//       // Not enough space below, but enough above
//       position.bottom = `${buttonRect.height + 8}px`;
//       position.transformOrigin = 'bottom left';
//     } else {
//       // Not enough space either way
//       if (spaceBelow > spaceAbove) {
//         // More space below
//         position.top = `${buttonRect.height + 8}px`;
//         position.maxHeight = `${spaceBelow - 20}px`;
//         position.transformOrigin = 'top left';
//       } else {
//         // More space above
//         position.bottom = `${buttonRect.height + 8}px`;
//         position.maxHeight = `${spaceAbove - 20}px`;
//         position.transformOrigin = 'bottom left';
//       }
//     }

//     // Horizontal positioning
//     const buttonLeft = buttonRect.left;
//     const buttonRight = buttonRect.right;
//     const spaceOnRight = viewport.width - buttonLeft - padding;
//     const spaceOnLeft = buttonRight - padding;
    
//     if (spaceOnRight >= dropdownWidth) {
//       // Enough space on the right (default alignment)
//       position.left = '0';
//     } else if (spaceOnLeft >= dropdownWidth) {
//       // Not enough space on right, align to right edge of button
//       position.right = '0';
//       position.transformOrigin = position.transformOrigin.replace('left', 'right');
//     } else {
//       // Not enough space on either side
//       // Position to maximize visibility
//       if (buttonLeft < viewport.width / 2) {
//         // Button is on left side of screen
//         position.left = `${Math.max(0, padding - buttonLeft)}px`;
//       } else {
//         // Button is on right side of screen
//         position.right = `${Math.max(0, buttonRight - (viewport.width - padding))}px`;
//       }
//     }

//     setDropdownPosition(position);
//   }, [isDropdownOpen, perPageOptions.length]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Calculate position when dropdown opens
//   useEffect(() => {
//     if (isDropdownOpen) {
//       calculatePosition();
//     }
//   }, [isDropdownOpen, calculatePosition]);

//   // Handle resize and scroll
//   useEffect(() => {
//     if (!isDropdownOpen) return;

//     const handleResize = () => {
//       calculatePosition();
//     };

//     const handleScroll = () => {
//       // Recalculate position on scroll
//       calculatePosition();
//     };

//     window.addEventListener('resize', handleResize);
//     window.addEventListener('scroll', handleScroll, true);
    
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       window.removeEventListener('scroll', handleScroll, true);
//     };
//   }, [isDropdownOpen, calculatePosition]);

//   const handleItemSelect = (option) => {
//     onItemsPerPageChange(option === 'All' ? 'All' : option);
//     setIsDropdownOpen(false);
//   };

//   return (
//     <div className="flex flex-wrap items-center justify-between mt-4 gap-4">
//       {/* Left: Showing items text */}
//       <div>
//         <span className="text-sm">
//           {`Showing ${startItem} - ${endItem} of ${totalItems}`}
//         </span>
//       </div>

//       {/* Right: Dropdown and Navigation */}
//       <div ref={dropdownRef} className="relative inline-block text-left">
//         <div className="flex border rounded-md overflow-hidden divide-x divide-gray-300">
//           <button
//             ref={buttonRef}
//             onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//             className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 transition-colors"
//           >
//             <Settings size={16} />
//             <span>{itemsPerPage === 'All' ? 'All per page' : `${itemsPerPage} per page`}</span>
//           </button>

//           <div className="flex items-center px-3 py-2 text-sm">
//             <button
//               onClick={() => onPageChange(Math.max(1, currentPage - 1))}
//               disabled={currentPage === 1 || itemsPerPage === 'All'}
//               className={`mr-2 transition-opacity ${
//                 currentPage === 1 || itemsPerPage === 'All' 
//                   ? 'opacity-50 cursor-not-allowed' 
//                   : 'hover:bg-gray-100 rounded'
//               }`}
//             >
//               <ChevronLeft size={20} />
//             </button>
//             <span className="font-medium text-gray-700">
//               {startItem} - {endItem}
//             </span>
//             <button
//               onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
//               disabled={currentPage === totalPages || itemsPerPage === 'All'}
//               className={`ml-2 transition-opacity ${
//                 currentPage === totalPages || itemsPerPage === 'All' 
//                   ? 'opacity-50 cursor-not-allowed' 
//                   : 'hover:bg-gray-100 rounded'
//               }`}
//             >
//               <ChevronRight size={20} />
//             </button>
//           </div>
//         </div>

//         {isDropdownOpen && (
//           <div 
//             className="absolute z-60 w-32 bg-white border border-gray-200 shadow-lg rounded-md overflow-auto"
//             style={{
//               ...dropdownPosition,
//               animation: 'dropdownFade 0.2s ease-out',
//               transformOrigin: dropdownPosition.transformOrigin
//             }}
//           >
//             {perPageOptions.map((option) => (
//               <div
//                 key={option}
//                 onClick={() => handleItemSelect(option)}
//                 className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
//               >
//                 {option === 'All' ? 'All per page' : `${option} per page`}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Add animation styles */}
//       <style>{`
//         @keyframes dropdownFade {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Pagination;




import React, {
  useState,
  useRef,
  useLayoutEffect,
  useEffect,
  useCallback,
} from "react";
import { createPortal } from "react-dom";
import { ChevronLeft, ChevronRight, Settings } from "lucide-react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [styles, setStyles] = useState({ opacity: 0 });

  const perPageOptions = [10, 25, 50, 75, 100, 200, "All"];

  /* ---------- Pagination Logic ---------- */

  const totalPages =
    itemsPerPage === "All"
      ? 1
      : Math.ceil(totalItems / itemsPerPage);

  const startItem =
    itemsPerPage === "All"
      ? 1
      : (currentPage - 1) * itemsPerPage + 1;

  const endItem =
    itemsPerPage === "All"
      ? totalItems
      : Math.min(currentPage * itemsPerPage, totalItems);

  /* ---------- Dropdown Position ---------- */

  const calculatePosition = useCallback(() => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    const vh = window.innerHeight;
    const vw = window.innerWidth;

    const optionHeight = 36;
    const dropdownHeight =
      perPageOptions.length * optionHeight + 12;

    const width = rect.width;
    const gap = 6;

    let style = {
      position: "fixed",
      width,
      left: rect.left,
      zIndex: 60,
      opacity: 1,
    };

    /* Vertical */

    const spaceBelow = vh - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow > dropdownHeight || spaceBelow > spaceAbove) {
      style.top = rect.bottom + gap;
      style.transformOrigin = "top";
    } else {
      style.bottom = vh - rect.top + gap;
      style.transformOrigin = "bottom";
    }

    /* Horizontal Safety */

    if (style.left + width > vw) {
      style.left = vw - width - 8;
    }

    if (style.left < 8) {
      style.left = 8;
    }

    setStyles(style);
  }, [perPageOptions.length]);

  /* ---------- Layout Sync ---------- */

  useLayoutEffect(() => {
    if (!open) return;

    // First sync
    calculatePosition();

    // Second sync AFTER paint (fixes first-load shift)
    const raf = requestAnimationFrame(() => {
      calculatePosition();
    });

    window.addEventListener("resize", calculatePosition);
    window.addEventListener("scroll", calculatePosition, true);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", calculatePosition);
      window.removeEventListener("scroll", calculatePosition, true);
    };
  }, [open, calculatePosition]);


  /* ---------- Outside Click ---------- */

  useEffect(() => {
    const handler = (e) => {
      if (
        open &&
        !buttonRef.current?.contains(e.target) &&
        !dropdownRef.current?.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () =>
      document.removeEventListener("mousedown", handler);
  }, [open]);

  /* ---------- Select ---------- */

  const handleSelect = (value) => {
    onItemsPerPageChange(value === "All" ? "All" : value);
    setOpen(false);
  };

  /* ---------- Render ---------- */

  return (
    <div className="flex flex-wrap items-center justify-between mt-4 gap-4 w-full">

      {/* Left Info */}
      <div>
        <span className="text-sm text-gray-500">
          Showing {startItem} - {endItem} of {totalItems}
        </span>
      </div>

      {/* Right Controls */}
      <div className="flex items-center gap-2">

        {/* Dropdown Button */}
        <button
          ref={buttonRef}
          onClick={() => setOpen((p) => !p)}
          className="
            flex items-center gap-2
            px-3 py-2 text-sm
            bg-gray-50
            hover:bg-gray-100
            border border-gray-200
            rounded-md
            text-gray-700
          "
        >
          <Settings size={16} />

          {itemsPerPage === "All"
            ? "All per page"
            : `${itemsPerPage} per page`}
        </button>

        {/* Page Controls */}
        <div
          className="
            flex items-center
            border border-gray-200
            rounded-md
            px-2 py-1
            bg-white
          "
        >
          <button
            onClick={() =>
              onPageChange(Math.max(1, currentPage - 1))
            }
            disabled={currentPage === 1 || itemsPerPage === "All"}
            className="p-1 disabled:opacity-40"
          >
            <ChevronLeft size={20} />
          </button>

          <span className="px-2 text-sm font-medium">
            {startItem} - {endItem}
          </span>

          <button
            onClick={() =>
              onPageChange(
                Math.min(totalPages, currentPage + 1)
              )
            }
            disabled={
              currentPage === totalPages ||
              itemsPerPage === "All"
            }
            className="p-1 disabled:opacity-40"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      {/* Dropdown (Portal) */}
      {open &&
        createPortal(
          <div
            ref={dropdownRef}
            style={styles}
            className="
              bg-white
              border border-gray-200
              shadow-xl
              rounded-md
              overflow-hidden
            "
          >
            {perPageOptions.map((opt) => (
              <div
                key={opt}
                onClick={() => handleSelect(opt)}
                className="
                  px-4 py-2 text-sm
                  cursor-pointer
                  hover:bg-gray-50
                  text-gray-700
                "
              >
                {opt === "All"
                  ? "All per page"
                  : `${opt} per page`}
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

export default Pagination;

